import angular from 'angular';
import 'ng-file-upload';

const librariesServices = (function () {
    'use strict';

    return angular.module('applicationModule.librariesServices', ['ngFileUpload']);
})();

librariesServices.factory('Libraries', ['LibrariesAPI', 'AppsoupAPI', 'Upload', function (LibrariesAPI, AppsoupAPI, Upload) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/library/';

    return {
        get: function (appId) {
            return LibrariesAPI.get(appId);
        },
        remove: function (appId, fileUrl) {
            return LibrariesAPI.remove(appId, fileUrl);
        },
        upload: function (appId, file) {
            if (angular.isDefined(file)) {
                return Upload.upload({
                    url: API_URL + 'upload/' + appId,
                    method: 'POST',
                    headers: {'Content-Type': file.type},
                    sendObjectsAsJsonBlob: true,
                    file: file
                });
            }
        }
    };
}]);

librariesServices.service('LibrariesAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/library/';

    this.get = function (appId) {
        return $http.get(API_URL + appId);
    };
    this.remove = function (appId, fileUrl) {
        return $http.post(API_URL + appId, fileUrl);
    };
}]);

export default librariesServices;
